<template>
  <v-card>
    <v-form @submit.prevent="submitAddUser()" ref="addUserForm">
      <v-card-title>
        <span class="headline">Add User</span>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field label="* Name" v-model="user.name" :rules="nameRules"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="* Email" v-model="user.email" :rules="emailRules"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="* Password"
              type="password"
              v-model="user.password"
              :rules="passwordRules"
              :error-messages="passwordsMatchErrorMessage"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="* Confirm Password"
              type="password"
              v-model="user.confirmedPassword"
              :rules="passwordRules"
              :error-messages="passwordsMatchErrorMessage"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              label="* User Authorization"
              :items="userAuthClasses"
              v-model="user.userAuthClassId"
              item-text="name"
              item-value="id"
              :rules="userAuthClassRules"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn :color="primaryNeutral" flat type="submit" :loading="addingUser">Add</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import UserService from "@/services/requests/userService";
import UserValidation from "@/services/validation/userValidation";

import PasswordMatch from "./passwordMatch";
export default {
  mixins: [UserValidation, PasswordMatch],
  data() {
    return {
      user: {
        name: "",
        email: "",
        password: "",
        confirmedPassword: "",
        userAuthClassId: null
      },
      addingUser: false,
      prefix: "user"
    };
  },
  methods: {
    submitAddUser() {
      if (!this.$refs.addUserForm.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      this.addUser();
    },
    addUser() {
      this.loading = true;

      UserService.addUser(this.user)
        .then(result => {
          this.loading = false;
          //console.log(result);
          this.$store.commit("users/addToArrayState", {
            prop: "users",
            value: result.data.result
          });
          this.resetForm();
          this.snack({ color: "green", text: "User was added" });
          this.close();
        })
        .catch(err => {
          this.snackError();
          this.addingUser = false;
          console.log(err);
        });
    },
    getUserAuthClasses() {
      UserService.getAllUserAuthClasses()
        .then(result => {
          //console.log(result);
          this.userAuthClasses = result.data.result;
        })
        .catch(err => {
          this.snackError();
        });
    },
    resetForm() {
      this.user.name = "";
      this.user.email = "";
      this.user.password = "";
      this.user.confirmedPassword = "";
      this.user.userAuthClassId = "";
      this.$refs.addUserForm.resetValidation();
    },
    close() {
      this.$emit("close");
    }
  },
  computed: {
    userAuthClasses: Store.getSet({ store: "users", prop: "userAuthClasses" }),
    passwordsMatch() {
      if (this[this.prefix].password == this[this.prefix].confirmedPassword)
        return true;

      return false;
    }
  },
  mounted() {
    this.getUserAuthClasses();
  }
};
</script>

<style>
</style>
